var path = 'features/account/templates/token_updated.html';
var html = "<div class=\"container success\">\n    <div class=\"section-header\">\n        <h1 class=\"main-title\">{{tokenCtrl.tokenData.header}}</h1>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"box wrapper bg-white text-center col-xs-12 col-sm-5\">\n            <p class=\"text-green roboto-slab\">{{tokenCtrl.tokenData.subHeader}}</p>\n            <p>{{ tokenCtrl.tokenData.subTitle }}</p>\n            <p>{{ tokenCtrl.tokenData.message }}</p>\n        </div>\n    </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/features/account/templates/token_updated.html
 ** module id = 64
 ** module chunks = 0
 **/